import React from "react";
import { CallerContext } from "../components/common/CallerContext";
import { EBButton } from "../components/common/EBButton";
import { UrlHelpers } from "../helpers/Helpers";
import { WindowHelpers } from "../helpers/Window.helper";
import { ReactMatch } from "../model/ReactMatchObj";
import { PageProps } from "../model/views/PageProps";
import { AddOrUpdateQuestionForm } from "./AddOrUpdateQuestionForm";
import { Question } from "./Question.Model";
import { QuestionsAPI } from "./QuestionsAPI";

interface UpdateQuestionPageContentPathParams {
  questionId: number;
}

interface UpdateQuestionPageContentProps extends PageProps {
  match: ReactMatch<UpdateQuestionPageContentPathParams>;
}

interface UpdateQuestionPageContentState {
  question: Question;
  isEditingWithAi?: boolean;
}
export class UpdateQuestionPageContent extends React.Component<
  UpdateQuestionPageContentProps,
  UpdateQuestionPageContentState
> {
  componentDidMount() {
    QuestionsAPI.fetchQuestionDetails(this.props.match.params.questionId)
      .executeV2()
      .then((question) => {
        this.setState({ question: question });
      });
  }

  handleEditWithAi = () => {
    this.setState({ isEditingWithAi: true }); // To show a loading indicator
    QuestionsAPI.editQuestionWithAi(this.state.question.id)
      .executeV2()
      .then((updatedQuestion) => {
        this.setState({ isEditingWithAi: false });
        const successMessage = "Question updated successfully with AI!";
        const redirectUrl = UrlHelpers.getQuestionDetailsUrl(
          updatedQuestion.slug,
          updatedQuestion.id,
          successMessage
        );
        WindowHelpers.redirect(redirectUrl);
      })
      .catch((error) => {
        this.setState({ isEditingWithAi: false });
      });
  };

  render() {
    let callBack = (
      question: Question,
      callerContext: CallerContext
    ): Promise<void> => {
      return new Promise<void>((resolve, reject) => {
        const successMessage = "Question saved succesfully!!!";
        const redirectUrl = UrlHelpers.getQuestionDetailsUrl(
          question.slug,
          question.id,
          successMessage
        );
        WindowHelpers.redirect(redirectUrl);
        resolve();
      });
    };

    const { user } = this.props;
    const { question, isEditingWithAi } = this.state ?? {};

    return (
      <div className="main-container UpdateQuestionPage">
        {user && question && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3>Update Question</h3>
              {user.basicDetails.isAdmin && (
                <EBButton
                  text={{ normal: "Edit with AI", submitting: "Editing..." }}
                  onClick={this.handleEditWithAi}
                  loading={isEditingWithAi}
                  disabled={isEditingWithAi}
                />
              )}
            </div>

            <div className="card">
              <div className="card-body">
                <AddOrUpdateQuestionForm
                  callerContext={{}}
                  callback={callBack}
                  question={question}
                  user={user}
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
